import React from 'react';

import { Wrapper } from './Wrapper';
import { BarContainer } from './BarContainer';

interface IProps {
    style?: React.CSSProperties;
    hideOnMobile?: boolean;
}

export const ButtonBar: React.FC<IProps> = ({
    style,
    hideOnMobile,
    children,
}) => (
    <Wrapper hideOnMobile={hideOnMobile} style={{ ...style }}>
        <BarContainer>{children}</BarContainer>
    </Wrapper>
);
